import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const InputCheckerLeftMenuIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 16,
    width,
    height,
    color = 'currentColor',
    onClick,
    strokeWidth = 1.5,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      width={width}
      height={height}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <rect
        x="11.4"
        y="5.1"
        width="7.2"
        height="9.4"
        rx="1.2"
        stroke={color}
        strokeWidth={strokeWidth}
        opacity="0.55"
      />
      <rect
        x="8.4"
        y="7.2"
        width="7.2"
        height="9.4"
        rx="1.2"
        stroke={color}
        strokeWidth={strokeWidth}
        opacity="0.78"
      />
      <rect
        x="5.4"
        y="9.3"
        width="7.2"
        height="9.4"
        rx="1.2"
        stroke={color}
        strokeWidth={strokeWidth}
      />
    </BaseIcon>
  ),
);

InputCheckerLeftMenuIcon.displayName = 'InputCheckerLeftMenuIcon';
